import { render, staticRenderFns } from "./preDeliveryNote.vue?vue&type=template&id=6fbc8e0c&scoped=true&"
import script from "./preDeliveryNote.vue?vue&type=script&lang=js&"
export * from "./preDeliveryNote.vue?vue&type=script&lang=js&"
import style0 from "./preDeliveryNote.vue?vue&type=style&index=0&id=6fbc8e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc8e0c",
  null
  
)

export default component.exports